import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const CreditScoreBox = ({heading, description, img}) => {
    return (
        <div>
            {img && <img src={img} />}
            <div styleName={"styles.wrapper"}>
                <p styleName={"styles.heading"}>{heading}</p>
                <p styleName={"styles.subText"}>{description}</p>
            </div>
        </div>
    );
};

CreditScoreBox.propTypes = {
    heading: PropTypes.string,
    img: PropTypes.object,
    description: PropTypes.string
};

export default CreditScoreBox;
